<style lang="scss" scoped>
  @import 'common/sass/reuse.SCSS';
</style>

<template>
  <div class="maintenance-box">
    <div class="panel">
      <sll-table 
        :tableHead="tableHead"
        :tbodyData="tbodyData"  
        :page="page"
        :selPage="selPage"
        :tip="tip"
        @tableChange="requestEngine">
        <div slot="search" class="search-box">
          <div class="select-type">
            <span v-text="lan.typeText"></span>
            <el-select v-model="type" style="width:80px" @change="requestEngine">
                <el-option v-for="(val, key) in lan.typeMaps" :key="key" :label="val" :value="key">
                </el-option>
            </el-select>
          </div>
          <div class="select-type">
            <span v-text="lan.logDate"></span>
            <el-date-picker 
              v-model="logDate" 
              type="datetimerange" 
              :picker-options="pickerOptions"
              :range-separator="lan.to"
              :start-placeholder="lan.startTime"
              :end-placeholder="lan.endTime"
              align="right">
            </el-date-picker>
          </div>
          <div class="select-type">
            <span v-text="lan.modifiedID"></span>
            <el-input v-model="modifiedID"  :placeholder="lan.inputDefault" style="width:150px;"></el-input>
          </div>
          <div class="select-type">
            <span v-text="lan.description"></span>
            <el-input v-model="description"  :placeholder="lan.inputDefault" style="width:150px;"></el-input>
          </div>
          <div class="select-type">
            <el-button type="primary" @click="requestEngine" v-text="lan.searchText"></el-button>
          </div>
        </div>
      </sll-table>
    </div>
  </div>
</template>

<script>
import { URL_AUDITLOG} from 'api/api'
import { format } from 'common/js/util'
import sllTable from 'components/reuseTable'
export default {
  mixins: [
    require("common/mixin/base").base({lan: "auditLog"})
  ],
  data() {
    return {
      type: '-1',
      logDate: [new Date().setTime(new Date().getTime() - 36 * 1e5 * 24 * 30), new Date()],
      modifiedID: '',
      description: '',
      tbodyData: [],
      page: {
        active: 1,
        pageLeng: 0,
        offset: 0,
      },
      selPage: {
        list: ['5','10','25','50'],
        active: localStorage.pageMaxIndex, 
        limit: [5, 10, 25, 50][localStorage.pageMaxIndex]
      },
      tip: ['OLD_VALUE','NEW_VALUE']
    }
  },
  computed: {
    tableHead() {
      return this.lan.tableHead
    },
    pickerOptions() {
      let arr = [];
      let dateArr = [
        {text:this.lan.lastWeek, day:7}, 
        {text:this.lan.lastMonth, day:30}, 
        {text:this.lan.lastThreeMonths, day:90}
      ];
      for(let v of dateArr) {
        arr.push({
          text: v.text,
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 36 * 1e5 * 24 * v.day);
            picker.$emit('pick', [start, end]);
          }
        })
      }
      return {
        shortcuts: arr
      }
    }
  },
  components: {
    sllTable,
  },
  created() {
    this.requestEngine()
  },
  methods: {
    requestEngine() {
      if(isNaN(new Number(this.modifiedID))){
        this.$message({message: this.lan.notNumber,type: 'warning'});
        return;
      }
      let option = {type: this.type, pageNum: this.page.active, pageSize: +this.selPage.limit};
      if(this.logDate) {
        option.start = format(this.logDate[0]);
        option.end = format(this.logDate[1])
      }
      if(this.modifiedID) option.modifiedID = this.modifiedID;
      if(this.description) option.description = this.description;
      this.$http.post(URL_AUDITLOG, option).then(res => {
        this.page.pageLeng = res.data.data.count;
        this.tbodyData = res.data.data.data;
        this.resolveData();
      }).catch(e=>{
        alert(e);
      })
    },
    resolveData(){
      if (Object.prototype.toString.call(this.tbodyData) == "[object Array]") {
        this.tbodyData.forEach(item => {
          item.type = this.lan.typeMaps[item.TYPE]
          item.LOG_DATE = format(item.LOG_DATE)
        });
      }
    }
  },
  watch: {
    lan() {
      this.resolveData()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/auditLog/auditLog.vue